import { render, staticRenderFns } from "./OutgoingDispatch.vue?vue&type=template&id=6959922c&scoped=true&"
import script from "./OutgoingDispatch.vue?vue&type=script&lang=js&"
export * from "./OutgoingDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959922c",
  null
  
)

export default component.exports